import React, { useState } from "react";
import { renameTemplate } from "../../Context/Template";
import "../Partials/Rename.css";

interface RenameProps {
  templateURL: string;
  currentTitle: string;
  onClose: () => void;
  onRenamed: () => void;
}

const Rename: React.FC<RenameProps> = ({ templateURL, currentTitle, onClose, onRenamed }) => {
  const [newTitle, setNewTitle] = useState(currentTitle);

  const handleRename = async () => {
    const res = await renameTemplate(templateURL, newTitle);
    if (res) {
      onRenamed();
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label="Rename template">
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header" id="rename-modal-title">Rename Template</div>
        <label htmlFor="rename-input" className="sr-only" style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0,0,0,0)" }}>New template name</label>
        <input className="renameInput"
          id="rename-input"
          type="text"
          value={newTitle}
          onChange={e => setNewTitle(e.target.value)}
          aria-labelledby="rename-modal-title"
        />
        <div className="modal-actions">
          <button className="modal-action renamebtn" onClick={handleRename} aria-label="Rename template"><span className="button-text">Rename</span></button>
          <button className="modal-action cancel" onClick={onClose} aria-label="Cancel rename"><span className="button-text">Cancel</span></button>
        </div>
      </div>
    </div>
  );
};

export default Rename;
